import type { Dispatch, RefObject, SetStateAction } from 'react'

export const InputType = {
  Tel: 'tel',
  Password: 'password',
} as const
export type InputType = (typeof InputType)[keyof typeof InputType]

export type AuthCodeRef = {
  focus: () => void
  clear: () => void
}

export type HandlersProps = {
  sendResult: () => void
  inputsRef: RefObject<HTMLInputElement[]>
  setIsFocused: Dispatch<SetStateAction<boolean>>
  lengthPinCode: number
}

export type FirstFieldUpdateProps = {
  valueAfterInvalid: string
  inputsRef: RefObject<HTMLInputElement[]>
  setIsFocused: Dispatch<SetStateAction<boolean>>
}
